import React from 'react';
import {
  Grid,
} from '@material-ui/core';

import PageHeader from 'components/PageHeader';
import List from './List';
import Form from './Form';
import { CertificadoContextProvider } from './Context/list';
import { MarcaContextProvider } from './Context/marcas';
import { FiltrosContextProvider } from './Context/filtros';
import Filtros from './Filtros';

function AssinaturaCertificado() {
  return (
    <div>
      <PageHeader title="Consulta de Certificados" subheading="Consulta" />
      <Grid container justify="center" alignItems="center">
        <Grid item sm={12} md={12} lg={8} style={{ maxWidth: '100%' }}>
          <CertificadoContextProvider>
            <FiltrosContextProvider>
              <MarcaContextProvider>
                <Form />
                <Filtros />
              </MarcaContextProvider>
            </FiltrosContextProvider>
            <List />
          </CertificadoContextProvider>
        </Grid>
      </Grid>
    </div>
  );
}

export default AssinaturaCertificado;
